import type { StreetNumber } from '@gov-design-system-ce/react-form';
import type { Maybe } from '@gov-nx/core/types';

export const composeAddress = (
	street: Maybe<string>,
	streetNumbers?: StreetNumber
): string => {
	const { orientacniCislo, popisneCislo } = streetNumbers ?? {};
	if (!popisneCislo && !orientacniCislo && !street) return '';

	const composedNumbers = popisneCislo
		? orientacniCislo
			? `${popisneCislo}/${orientacniCislo}`
			: popisneCislo
		: (orientacniCislo ?? '');

	if (!street) return composedNumbers;

	return `${street} ${composedNumbers}`.trim();
};
